module.exports = __webpack_public_path__ + "img/EmiratesLandingPage-highlight-arrow.6edd1dec.png";